import { render, staticRenderFns } from "./GraphDetail61.vue?vue&type=template&id=1f31637a&scoped=true"
import script from "./GraphDetail61.vue?vue&type=script&lang=js"
export * from "./GraphDetail61.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f31637a",
  null
  
)

export default component.exports